import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextLeptin = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

FPro-opiomelanocortin (POMC)-expressing neurons and agouti-related protein (AGRP)-expressing neurons within the arcuate nucleus of the hypothalamus (ARC) act to sense circulating leptin (LEP) levels, 
which reflect fat mass.  <br />  <br /> 

These neurons signal to melanocortin 4 receptor (MC4R)-expressing neurons in the paraventricular nucleus of the hypothalamus (PVN), which controls appetite, thus linking long-term energy stores to feeding behaviour. <br />  <br /> 
 Binding of class 3 semaphorins (SEMA3) to their receptors NRP and PLXNA influences the projection of POMC neurons to the PVN.  <br />  <br /> 
 
 Binding of brain-derived neurotrophic factor (BDNF) to its receptor neurotrophic receptor tyrosine kinase 2 (NTRK2) is thought to be an effector of leptin-mediated synaptic plasticity of neurons, including those in the ARC and PVN.  <br />  <br /> 
 
 The transcription factor SIM1 is crucial for the proper development of the PVN. <br />  <br />  

 <Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes:</Typography>
<br /><br />
 'LEP', 'LEPR', 'POMC', 'PCSK1', 'MC4R', 'SIM1', 'BDNF', 'NTRK2', 'SEMA3', 'NRP', 'PLXNA', 'MRAP2', 'MSH', 'SH2B', 'SH2B1', 'AGRP'
 <br /><br /> 

 <Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Abbreviations </Typography>
<br /><br />
 +, agonist; −, antagonist; LEPR, leptin receptor; MRAP2, melanocortin receptor accessory protein 2; MSH, melanocyte-stimulating hormone; SH2B1, SH2B adaptor protein 1.

 <br /><br />
</Typography>

</div>
)
}